import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrder = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.44434 2.6665L4.44434 14.2221",
			stroke: "#006ADC",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5557 14.2222V1.77772",
			stroke: "#006ADC",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.11133 4.4445L4.62672 1.85318C4.60397 1.8295 4.57599 1.81053 4.54465 1.79754C4.5133 1.78455 4.4793 1.77783 4.4449 1.77783C4.41051 1.77783 4.37651 1.78455 4.34516 1.79754C4.31381 1.81053 4.28584 1.8295 4.26309 1.85318L1.77799 4.4445",
			stroke: "#006ADC",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2227 11.5555L11.7381 14.1468C11.7153 14.1705 11.6873 14.1895 11.656 14.2025C11.6246 14.2154 11.5906 14.2222 11.5562 14.2222C11.5218 14.2222 11.4878 14.2154 11.4565 14.2025C11.4251 14.1895 11.3972 14.1705 11.3744 14.1468L8.88932 11.5555",
			stroke: "#006ADC",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgOrder);
export default ForwardRef;
